import { Dropdown } from "react-bootstrap";

export const PER_PAGE_OPTIONS = [25, 50, 100, 200];

/**
 * Common header for list pages: title on the left; on the right any extra
 * filters (children), the search box and the "N per page" dropdown.
 * The per-page picker is a Bootstrap dropdown (not a native <select>) so the
 * open menu matches the web UI on every OS/browser.
 */
const ListHeader = ({
  title,
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search...",
  onSearch,
  limit,
  onLimitChange,
  perPageOptions = PER_PAGE_OPTIONS,
  children,
}) => (
  <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
    <h2 className="mb-0">{title}</h2>
    <div className="d-flex flex-wrap align-items-center gap-2">
      {children}
      <div className="input-group input-group-sm" style={{ width: "400px", maxWidth: "100%" }}>
        <input
          className="form-control"
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <button type="button" className="btn btn-outline-secondary" onClick={onSearch}>
          Search
        </button>
      </div>
      <Dropdown align="end">
        <Dropdown.Toggle size="sm" variant="outline-secondary">
          {limit} per page
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {perPageOptions.map((size) => (
            <Dropdown.Item
              key={size}
              as="button"
              type="button"
              active={size === limit}
              onClick={() => size !== limit && onLimitChange(size)}
            >
              {size} per page
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  </div>
);

export default ListHeader;
